import { useBreakpoints } from 'hooks/useBreakpoints';
import React from 'react';
import { Desktop } from './Desktop/Desktop';
import type { IEntriesProps } from './IEntries';
import { Mobile } from './Mobile/Mobile';

export const ResponsiveScrollItems: React.FC<IEntriesProps> = ({ ...props }) => {
  const { browser } = useBreakpoints();
  const isGreaterThanTablet = browser.greaterThan.tablet;
  return isGreaterThanTablet ? <Desktop {...props} /> : <Mobile {...props} />;
};
